module.exports = __webpack_public_path__ + "38c4b2f465398124e5e1b5244f1fe273.pdf";